import { getApiInstance, getOAuthToken } from './ApiToken'

export default {
  async getPods (params) {
    const api = await getApiInstance()
    try {
      const response = api.get('podRegistry', { params })
      return response
    } catch (error) {
      if (error.response && error.response.status === 401) {
        getOAuthToken()
        const api = getApiInstance()
        const response = api.get('podRegistry', { params })
        return response
      }
      throw error
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/PodsService.js